import './form.scss';

import Pristine from 'pristinejs';
import axios from 'axios';
import { checkAndLoadFiles, createElementFromHTML, getOffset, smoothScrollTo } from './../../utilities/js/helper';

import { WidgetInstance } from 'friendly-challenge';

class FormHandler {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-form',
            buttonDisabledClass: 'button--disabled',
            scrollOffset: 50
        };

        this.settings = Object.assign({}, defaults, options);
        this.$form = $element;
        this.$header = document.querySelector('.siteheader');
        this.$loadingSpinner = createElementFromHTML(window.OPTIONS.loader);
        this.$$validationFields = this.$form.querySelectorAll('[data-pristine-validation]');
        this.validationFields = Array.from(this.$$validationFields);

        this.validationConfig = {
            classTo: 'is--pristine',
            errorClass: 'form-field--error',
            successClass: 'form-field--success',
            errorTextParent: 'form-field__error',
            errorTextTag: 'div',
            errorTextClass: ''
        };

        this.pristine = null;

        this.initialize();
    }

    initialize () {
        this.initForm();
    }

    initForm () {
        const $form = this.$form.querySelector('form');
        this.pristine = new Pristine($form, this.validationConfig, false);
        const $fields = $form.querySelectorAll('.is--pristine input, .is--pristine textarea, .is--pristine select');

        this.initCaptcha($form);

        $form.addEventListener('submit', (e) => {
            e.preventDefault();

            const valid = this.pristine.validate($fields);

            if (valid === true) {
                this.submitForm($form);
            } else {
                this.scrollToFirstError($form);
            }
        });

        this.$$validationFields.forEach($validationField => {
            if ($validationField.type !== 'file' && $validationField.type !== 'radio') {
                // Check validation for positive non-zero numbers
                if ($validationField.dataset.pristineValidation === 'positive-non-zero') {
                    this.pristine.addValidator($validationField,
                        (value) => {
                            return !isNaN(value) && Number(value) > 0;
                        }, 'Bitte geben Sie eine Zahl größer als 0 ein.'
                    );
                }
            }

            $validationField.addEventListener('input', () => {
                if ($validationField.type !== 'file' && $validationField.type !== 'radio') {
                    const validTarget = this.pristine.validate($validationField, false); // eslint-disable-line
                }
            });
        });

        $form.addEventListener('change', (e) => {
            const $target = e.target;

            if ($target.type !== 'file' && $target.type !== 'radio' && !this.validationFields.includes($target) && $target.closest('.is--pristine')) {
                const validTarget = this.pristine.validate($target, false); // eslint-disable-line
            }

            /*
            const $uploader = $form.querySelector('[data-uploader="root"]');
            if ($uploader && $uploader.classList.contains('has--error')) {
                valid = false;
            }
            */

            this.handleSubmitButton($form, $fields);
        });

        this.handleSubmitButton($form, $fields);
    }

    handleSubmitButton ($form, $fields) {
        const valid = this.pristine.validate($fields, true);
        const $button = $form.querySelector('button[type="submit"]');

        if (valid === true) {
            $button.classList.remove(this.settings.buttonDisabledClass);
        } else {
            $button.classList.add(this.settings.buttonDisabledClass);
        }
    }

    initCaptcha ($form) {
        const $friendlyCaptcha = $form.querySelector('.frc-captcha');
        if ($friendlyCaptcha) {
            const widget = new WidgetInstance($friendlyCaptcha); // eslint-disable-line
        }
    }

    scrollToFirstError ($form) {
        let headerHeight = 0;
        if (this.$header !== null) {
            headerHeight = parseInt(this.$header.offsetHeight);
        }
        const $firstError = $form.querySelectorAll('.form-field--error')[0];
        if ($firstError) {
            const errorScrollPosition = getOffset($firstError);
            smoothScrollTo(0, errorScrollPosition.top - headerHeight - this.settings.scrollOffset);
        }
    }

    submitForm ($form) {
        const $button = $form.querySelector('button[type="submit"]');
        const formMethod = $form.getAttribute('method');
        const formAction = $form.getAttribute('action');
        const formData = new FormData($form);

        if ($button !== null) {
            $button.appendChild(this.$loadingSpinner);
            $button.setAttribute('disabled', true);
        }

        axios({
            method: formMethod,
            url: formAction,
            data: formData
        })
            .then((result) => {
                if (result && result.data) {
                    const $result = createElementFromHTML(result.data);
                    const $resultContent = $result.innerHTML;
                    let $resultContainer = null;

                    if ($resultContent) {
                        let headerHeight = 0;
                        if (this.$header !== null) {
                            headerHeight = parseInt(this.$header.offsetHeight);
                        }

                        if ($result.getAttribute('data-form') === 'success') {
                            let successScrollPosition = 0;

                            if (this.$form.getAttribute('data-formtarget')) {
                                const targetId = this.$form.getAttribute('data-formtarget');
                                const $target = document.getElementById(targetId);

                                if ($target) {
                                    successScrollPosition = getOffset($target);
                                }

                                $target.innerHTML = $resultContent;
                                $resultContainer = $target;
                            } else {
                                this.$form.innerHTML = $resultContent;
                                successScrollPosition = getOffset(this.$form);
                                $resultContainer = this.$form;
                            }

                            smoothScrollTo(0, successScrollPosition.top - headerHeight - this.settings.scrollOffset);
                        } else {
                            this.$form.innerHTML = $resultContent;
                            this.initForm();

                            this.scrollToFirstError($form);

                            $resultContainer = this.$form;
                        }
                    }

                    const contentUpdateEvent = new CustomEvent('content.loaded', {
                        view: window,
                        bubbles: true,
                        cancelable: false,
                        detail: {
                            $context: $resultContainer
                        }
                    });
                    window.dispatchEvent(contentUpdateEvent);

                    checkAndLoadFiles($result);

                    window.checkInview(window.eventScroller);
                }
            })
            .catch((error) => {
                throw Error(error);
            });
    }
}

export { FormHandler };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$form = $context.querySelectorAll('[data-form="root"]');
        for (let i = 0; i < $$form.length; i++) {
            const $form = $$form[i];

            const formAPI = new FormHandler($form);
            $form.API = formAPI;
        }
    }
});
